import UITile from 'UIComponents/tile/UITile';
import { TileSection } from 'foundations-components/transitional/components/Tile';
import styled from 'foundations-theming-specialty/utils';

/** CSS taken from here - https://codyhouse.co/nuggets/css-gradient-borders#alternative-approach.
 * This is a way to create gradient borders in CSS while preseving border-radius. */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBreezeTile = styled(UITile).withConfig({
  displayName: "BreezeTile__StyledBreezeTile",
  componentId: "sc-72hux-0"
})(["width:100%;padding:", ";border:", " solid transparent;display:inline-block;border-radius:", ";background:linear-gradient( ", ",", " ) padding-box,", " border-box;"], ({
  theme
}) => theme.space['25'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['breeze-icon-full-page-loader-default']);
const BreezeTile = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyledBreezeTile, {
    children: /*#__PURE__*/_jsx(TileSection, {
      paddingBlockStart: "400",
      paddingInline: "500",
      paddingBlockEnd: "500",
      children: children
    })
  });
};
export default BreezeTile;